export default "__VITE_ASSET__f9653182__"